import { useLocalNavigate as useNavigate } from '@/lib/locale';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export const CheckoutCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen pt-10 pb-20 flex items-center justify-center" data-testid="cancel-page">
      <div className="max-w-2xl mx-auto px-6 text-center space-y-8">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-muted text-muted-foreground">
          <XCircle className="w-16 h-16" />
        </div>
        
        <div className="space-y-4">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground">
            {t('cancel.title')}
          </h1>
          <p className="text-lg text-muted-foreground">
            {t('cancel.text')}
          </p>
        </div>

        <div className="space-y-3">
          <Button
            data-testid="retry-checkout-btn"
            onClick={() => navigate('/checkout')}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold py-6 text-lg"
          >
            {t('cancel.retry')}
          </Button>
          <Button
            onClick={() => navigate('/shop')}
            variant="outline"
            className="w-full border-border text-foreground hover:bg-muted"
          >
            {t('cancel.continueShopping')}
          </Button>
        </div>
      </div>
    </div>
  );
};